import React from "react";

interface Props {
  widgetId: string;
  onWidgetError: (widgetId: string) => void;
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

// Note that for development purposes this component is cause broken
// widgets to be deleted. We may want some smarter functionality later.
export class WidgetErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error(`Widget (${this.props?.widgetId}) ran into an error. Removing for now.`);
    this.props.onWidgetError(this.props?.widgetId);
    // Can log to analytics here
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}
